<script>
  import ApplicationState from "../Stores/applicationStates"
  import { createEventDispatcher, onMount } from "svelte"
  const dispatch = createEventDispatcher()
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../Script/queryString"
  import { checkValidOlderDate } from "../Pages/Publish/SinglePublish/script"
  import notify from "../Script/notify"

  /**
   * @type {Boolean} whether to show a search input are not
   */
  export let search = true

  /**
   * @type {Boolean} whether to show or not a filter component
   */
  export let showFilterForm

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)
  /**
   * @type {String} start date for stats
   */
  let startDate = ""
  /**
   * @type {String} end date for stats
   */
  let endDate = ""

  /**
   * @type {String} - find list in search method using this string
   */
  let searchvalue = ""
  /**
   * @type {String} - which parameter need to search
   */
  let searchParam = "name"

  /**
   * Assign initial values here
   */
  onMount(() => {
    // const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    startDate = query.sdate ? new Date(query.sdate).toISOString().slice(0, 10) : ""
    endDate = query.edate ? new Date(query.edate).toISOString().slice(0, 10) : ""

    // const timeZoneOffsetMilliseconds = new Date().getTimezoneOffset() * 60000 // Convert minutes to milliseconds

    // startDate = query.sdate ? new Date(new Date(query.sdate).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 10) : ""
    // endDate = query.edate ? new Date(new Date(query.edate).getTime() - timeZoneOffsetMilliseconds).toISOString().slice(0, 10) : ""

    // if (query.sdate) startDate = query.sdate.slice(0, 16)
    // if (query.edate) endDate = query.edate.slice(0, 16)
    if (query.sname) searchvalue = query.sname
  })

  /**
   * @type {dateValidation} - document releasing notification
   */
  let dateValidation = {
    close() {},
  }

  /**
   * @type {dateValidation} - function for checking the given date is valid
   */
  const checkDate = (e) => {
    let value = ""
    dateValidation.close()
    let response = checkValidOlderDate(e)
    if (!response) {
      e.target.value = ""
      const info = "PAGE: Global (Date Filter)\nEVENT: On selecting a future date in the date input."
      dateValidation = notify.danger("Don't select future date", info)
    } else {
      value = e.target.value
    }
    return value
  }

  /**
   * @type {String} - filter components paramaters
   */
  let filterData = {
    search: {
      searchParam: searchParam,
    },
    date: {
      startDate: startDate,
      endDate: endDate,
    },
  }

  /**
   * @description function for dispatch the filtered data
   * @function filterList
   */
  const filterList = () => {
    searchvalue = searchvalue.trim()
    startDate ? (filterData.date.startDate = new Date(startDate).toISOString()) : (filterData.date.startDate = "")
    endDate ? (filterData.date.endDate = new Date(endDate).toISOString()) : (filterData.date.endDate = "")
    searchvalue ? (filterData.search.searchvalue = searchvalue) : (filterData.search.searchvalue = "")
    showFilterForm = false
    dispatch("callFilter", filterData)
  }

  /**
   * @description function for assigning which value is going to be searched
   * @function searchList
   */
  const searchList = () => {
    searchvalue ? (filterData.search.searchvalue = searchvalue) : (filterData.search.searchvalue = "")
    // dispatch("dummy", { filter: filterData, activePage: 1 })
  }

  /**
   * @type {Number} - to stop seTimeout function after a specified time in clearTimeout
   */
  let timer

  /**
   * @type {invalidNotification}
   */
  let invalidNotification = {
    close() {},
  }

  let allowedCharsRegex = /^[A-Za-z-\s()+&0-9.]*$/
  /**
   * function to check for given pattern to template name
   * @param e - to capture key event
   */
  const checkSpecialChars = async (e) => {
    const info = "PAGE: Global (Date Filter)\nEVENT: Validating invalid characters for the search input during onPaste/ onKeypress"

    try {
      // Destructure the type and key properties from the event object
      let { type, key } = e

      // Check if it's a keypress event and the pressed key is not allowed using regex pattern
      if (type === "keypress" && !allowedCharsRegex.test(key)) {
        // Prevent the default keypress behavior if the pressed key is not allowed
        e.preventDefault()
        //appending typed invalid characters before deleting
        searchvalue += key

        invalidNotification.close()
        // Show a danger notification indicating the allowed characters
        invalidNotification = notify.danger("Only letters, numbers, and special characters -()+&. are allowed.", info)
        //setting timer to display deleting invalid character
        setTimeout(() => {
          searchvalue = searchvalue.slice(0, -1)
        }, 100)
      } else if (type === "paste" || type === "blur") {
        // // Prevent the default paste behavior
        // e.preventDefault()
        // The plain text content retrieved from the clipboard
        let pastedText = ""

        if (type === "blur") {
          pastedText = searchvalue
        } else {
          // Get the pasted text from the clipboard
          let clipboardData = e.clipboardData || window.clipboardData
          pastedText = clipboardData.getData("text/plain")
        }

        setTimeout(() => {
          invalidNotification.close()
          // Check if the pasted text contains any invalid special characters
          if (!allowedCharsRegex.test(pastedText)) {
            // Remove any characters that are not allowed
            let sanitizedText = pastedText.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim()

            // Check if the sanitized text is the same as the original pasted text
            if (sanitizedText !== pastedText) {
              invalidNotification = notify.danger("Invalid special characters found. Only letters, numbers, and special characters -()+&. are allowed.", info)
            }

            // Set the input value to the sanitized text
            searchvalue = sanitizedText
          }
          //calling check maximum characters function
        }, 500)
      }
    } catch (error) {
      notify.danger(error, info)
    }
  }

  const validateDate = () => {
    if (new Date(startDate) > new Date(endDate)) {
      startDate = ""
      endDate = ""
      const info = "PAGE: Global (Date Filter)\nEVENT: On selecting 'To Date' before 'From Date'"
      dateValidation = notify.danger("The 'To Date' should not precede or be earlier than the 'From Date'.", info)
    }
  }
</script>

<form on:submit|preventDefault|stopPropagation={filterList} class="absolute right-0 top-24 z-20 w-full space-y-3 rounded-md border border-[#a0a1a580] bg-white px-3 pb-3 pt-3 shadow-md dark:bg-lightgray mobile:w-3/5 sm:px-6 sm:pt-6 lg:w-1/2">
  {#if search}
    <div>
      <div class="mb-3 flex items-center gap-3 text-xl dark:text-white">
        <i class="fa-solid fa-magnifying-glass" />
        <span class="text-lg font-semibold">Search</span>
      </div>
      <!-- <form on:submit|preventDefault|stopPropagation={searchList} class="relative flex w-full justify-between gap-3 sm:justify-end"> -->
      <input
        on:keypress={async (e) => {
          clearTimeout(timer)
          timer = setTimeout(await checkSpecialChars(e), 50)
        }}
        on:paste={checkSpecialChars}
        on:blur={() => (searchvalue = searchvalue.replace(/[^A-Za-z0-9\s-()+&.]/g, "").trim())}
        placeholder="Search {searchParam}"
        type="text"
        bind:value={searchvalue}
        class="w-full rounded-md border border-[#a0a1a580] bg-white py-2 pl-3 text-sm text-gray-800 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 dark:bg-transparent dark:text-white sm:pr-9 sm:text-sm md:w-full"
      />
      <!-- <button type="submit" class="absolute right-0 z-10 h-9 w-9 cursor-pointer items-center justify-center text-base font-semibold text-gray-800 hover:text-blue-400 focus:outline-none active:text-blue-600 disabled:cursor-not-allowed disabled:text-gray-300">
          <i class="fa-solid fa-magnifying-glass" />
        </button> -->
      <!-- </form> -->
    </div>
  {/if}
  <div>
    <div class="flex items-center gap-3 text-xl dark:text-slate-200">
      <i class="fa-solid fa-filter-list" />
      <span class="text-lg font-semibold">Filter</span>
    </div>
    <div class="p-2">
      <!-- <p class="text-xs text-gray-200 md:text-sm">You can filter the table list using below details.</p>
      <h1 class="text-sm font-bold dark:text-slate-100">Date</h1> -->
      <div class="flex items-center pt-6">
        <div class="relative w-1/2 border-r border-[#a0a1a580] pr-3">
          <input
            on:input={(e) => {
              startDate = checkDate(e)
              validateDate()
            }}
            style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;"
            type="date"
            bind:value={startDate}
            class="dateInput z-20 w-full border-none bg-transparent text-xs font-bold text-blue-500 outline-none placeholder:font-normal placeholder:text-blue-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 sm:pl-9 sm:pt-2 sm:text-sm"
          />
          <div class="absolute -top-2 left-1 z-10 hidden text-xl text-blue-500 sm:block">
            <i class="fa-solid fa-calendar-days text-base sm:text-2xl" />
          </div>
          <p class="absolute -top-4 text-xs dark:text-slate-200 sm:left-9 sm:text-sm">From&nbsp;Date</p>
        </div>
        <div class="relative ml-3 w-1/2">
          <input
            on:input={(e) => {
              endDate = checkDate(e)
              validateDate()
            }}
            style="color-scheme: {$ApplicationState.darkMode ? 'dark' : 'light'} ;"
            type="date"
            bind:value={endDate}
            class="dateInput z-20 w-full border-none bg-transparent text-xs font-bold text-blue-500 outline-none placeholder:font-normal placeholder:text-gray-500 invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:invalid:border-red-500 focus:invalid:ring-red-500 sm:pl-9 sm:pt-2 sm:text-sm"
          />
          <div class="absolute -top-2 left-1 z-10 hidden text-2xl text-blue-500 sm:block">
            <i class="fa-solid fa-calendar-days text-base sm:text-2xl" />
          </div>
          <p class="absolute -top-4 text-xs dark:text-slate-200 sm:left-9 sm:text-sm">To&nbsp;Date</p>
        </div>
      </div>
    </div>

    <div class="flex justify-between border-t border-[#a0a1a580] px-2 pt-3">
      <button
        on:click={() => {
          showFilterForm = false
          // sortData = jsonData
        }}
        type="button"
        class="flex h-9 w-full cursor-pointer items-center justify-center px-2 text-base font-medium text-red-500 hover:text-red-600 focus:outline-none active:text-red-500 disabled:cursor-not-allowed disabled:text-red-300 lg:px-4"
      >
        <i class="fa-solid fa-xmark" />
        &nbsp;&nbsp;Close
      </button>
      <button
        on:click={() => {
          filterData = {
            search: {
              searchParam: searchParam,
              searchvalue: "",
            },
            date: {
              startDate: "",
              endDate: "",
            },
          }
          showFilterForm = false
          dispatch("callFilter", filterData)
        }}
        type="button"
        class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-base font-medium text-blue-500 hover:text-blue-600 focus:outline-none active:text-blue-500 disabled:cursor-not-allowed disabled:text-blue-300 lg:px-4"
      >
        <i class="fa-solid fa-rotate-left" />
        &nbsp;&nbsp;Reset
      </button>
      <button type="submit" class="flex h-9 w-full cursor-pointer items-center justify-center border-l border-[#a0a1a580] px-2 text-base font-medium text-green-500 hover:text-green-600 focus:outline-none active:text-green-500 disabled:cursor-not-allowed disabled:text-green-300 lg:px-4">
        <i class="fa-solid fa-check" />
        &nbsp;&nbsp;Apply
      </button>
    </div>
  </div>
</form>

<style>
  input.dateInput {
    position: relative;
  }
  /* datetime-local */
  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
  }
</style>
